module.exports = __webpack_public_path__ + "static/media/profile-ico.144eefaf.svg";